import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '',
        loadComponent: () => import('./who-we-are.component').then(m => m.WhoWeAreComponent),
        data: {
          title: 'KudosHub | Who we are',
          description:'One of the best email validation, LiveChat & email marketing service providers, which also offers top-notch solutions for mobile apps, web design & development.',
          keywords: 'email validation service, livechat & customer support, email marketing, web design & development, mobile applications',
          ogTitle: 'KudosHub | Who we are',
          ogDesc: 'One of the best email validation, LiveChat & email marketing service providers, which also offers top-notch solutions for mobile apps, web design & development.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/who-we-are.webp',
          ogUrl: 'https://kudoshub.com/who-we-are',
          twitterTitle: 'KudosHub | Who we are',
          twitterDesc: 'One of the best email validation, LiveChat & email marketing service providers, which also offers top-notch solutions for mobile apps, web design & development.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/who-we-are.webp'
         }
      }
    ]
  }
];
